import { NewsList } from "@/components/News/NewsList";
import { Table } from "@/components/common/Table";
import { getBundesligaNews } from "@/data/news";
import { Season } from "@/models/Season";
import { News } from "@/models/types";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { Footer } from "../../../components/Footer";
import { TableList } from "../../../components/Table/TableList";
import { Nav } from "../../../components/common/FrontendNav";
import {
  getCurrentBundesligaTeams,
  getCurrentGameday,
  getCurrentSeason,
} from "../../../helper/api";
import { LeagueTeam } from "../../../models/LeagueTeam";

export async function getServerSideProps(context: any) {
  const { res } = context;
  res.setHeader(
    "Cache-Control",
    "public, max-age=300, stale-while-revalidate=360"
  );
  const currentSeason = await getCurrentSeason();

  const currentGamedayIndex = await getCurrentGameday(
    "Bundesliga",
    currentSeason.id
  );
  if (currentSeason) {
    return {
      redirect: {
        destination: `/bundesliga/table/${currentSeason.startYear}-${currentSeason.endYear}/${currentGamedayIndex}`,
        permanent: false,
      },
    };
  }

  const teams = await getCurrentBundesligaTeams();
  const { news } = await getBundesligaNews({
    locale: context.locale,
  });

  return {
    props: {
      teams,
      news,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface PageProps {
  teams: LeagueTeam[];
  news: News[];
  season: Season;
}
export default function Page({ teams, news, season }: PageProps) {
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <title>{`${t("Table_Tennis")} Bundesliga - TTBL - ${t(
          "Title_Table"
        )}`}</title>
      </Head>
      <div>
        <Nav />
        <div className="container max-lg:hidden">
          <TableList teams={teams} season={season} />
        </div>
        <div className="container container-padding-responsive lg:hidden">
          <Table teams={teams} season={season} />
        </div>
        <div className="container">
          <div className="grid grid-cols-[min-content_auto] gap-2 lg:flex lg:flex-row lg:ml-4">
            <div className="w-6 h-4 lg:self-center rounded-sm bg-green" />
            <div className="mr-4">{t("Playoffs")}</div>
            <div className="w-6 h-4 lg:self-center rounded-sm bg-red" />
            <div className="mr-4">{t("Relegation")}</div>
            <div className="font-thin text-gray-text">
              {t("Label_Encounters")}
            </div>
            <div className="mr-4">{t("Encounters")}</div>
            <div className="font-thin text-gray-text">{t("W")}</div>
            <div className="mr-4">{t("Wins")}</div>
            <div className="font-thin text-gray-text">{t("L")}</div>
            <div className="mr-4">{t("Losses")}</div>
            <div className="font-thin text-gray-text">+/-</div>
            <div className="">{t("Difference_between_won_and_lost_games")}</div>
          </div>
        </div>
        {news.length > 0 && (
          <div className="container container_py">
            <NewsList news={news} title="Bundesliga News" type="bundesliga" />
          </div>
        )}
        <Footer />
      </div>
    </>
  );
}
